import VirtualArrayRender from './VirtualArrayRender.component';

export default VirtualArrayRender;
